// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <wt-line-chart id=\"{{vm.id}}\" chart-data=\"vm.data\" series=\"vm.series\" options=\"vm.options\" zoom-control=\"vm.item\"></wt-line-chart> </div>";
// Exports
module.exports = code;